import { MatcherTypes } from "../../types/rules/MatcherTypes";
import { MatcherProperties, Matcher } from "./Matcher";

type FuzzyMatcherData = {
  fuzzyKey: string;
  threshold: number;
} & MatcherProperties;

class FuzzyMatcher extends Matcher implements FuzzyMatcherData {
  static FUZZY_PRECISION: number = 4;

  discriminator: MatcherTypes = "M_FUZZY";
  /* Fuzzy Matcher properties */
  fuzzyKey: string;
  /* Matcher properties */
  threshold: number;
  position: number;
  reusable: boolean;

  constructor(data: FuzzyMatcherData) {
    super();
    this.fuzzyKey = data.fuzzyKey ?? "";
    this.threshold = data.threshold;
    this.position = data.position;
    this.reusable = data.reusable ?? true;
  }
  isConfigured(): boolean {
    return this.fuzzyKey !== "";
  }
  clear(): void {
    this.fuzzyKey = "";
  }

  toMatcherData(): FuzzyMatcherData {
    return {
      discriminator: this.discriminator,
      position: this.position,
      fuzzyKey: this.fuzzyKey,
      threshold: this.threshold,
      reusable: this.reusable,
    };
  }

  getDiscriminator(): MatcherTypes {
    return this.discriminator;
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }

  getMatcherId(): string {
    return `${this.discriminator}-${this.fuzzyKey}-${this.threshold.toPrecision(FuzzyMatcher.FUZZY_PRECISION)}`;
  }

  static createTest(rest: Partial<FuzzyMatcherData> = {}): FuzzyMatcher {
    const data: FuzzyMatcherData = {
      fuzzyKey: "",
      threshold: 0,
      position: 0,
      reusable: true,
      discriminator: "M_FUZZY",
    };

    return new FuzzyMatcher({
      ...data,
      ...rest,
    });
  }
}

export { FuzzyMatcher, FuzzyMatcherData };
